import gql from "graphql-tag";

export const updateLanguage = gql`
  mutation updateLanguage($language: String) {
    updateProfile(language: $language) {
      language
    }
  }
`;
